import React, { useEffect, useRef, useState } from "react";
import InSchedulelayout from "./InSchedulelayout";
import { useFormik } from "formik";
import ToggleUp from "../../../../Components/Icons/ToggleUp";
import ToggleDown from "../../../../Components/Icons/ToggleDown";
import * as yup from "yup";
import axiosInstance from "../../../../Services/axiosCommon";
import { useParams } from "react-router-dom";
import NuDate from "../../../../Components/Utils/NuDate";
import { useToast } from "../../../../Components/Others/ToastServices";
import EditIcon from "../../../../Components/Icons/Edit";
import { GetAccess, GetRole } from "../../../../Components/Utils/roles";
import {
  SubmitButton,
} from "../../../../Components/Utils/Buttons";
import SendOTP from "./SendOTP";
import ModalContainer from "../../../../Components/Others/ModalContainer";
import CDynamicFormTwo from "../../../../Components/Utils/CDynamicFormTwo";

function FormSchedule({}) {
  const collectorSign = useRef(null);
  const clientSign = useRef(null);


  const [isCollectorSignEnabled, ] = useState(false);
  const [isClientSignEnabled, ] = useState(false);
  const [signOne, ] = useState(null);
  const [signTwo, ] = useState(null);
  const [filesList, ] = useState([]);
  const [removeSignOne, setRemoveSignOne] = useState("");
  const [removeSignTwo, setRemoveSignTwo] = useState("");
  const { scheduleViewId } = useParams();
  const [editModeIndex, setEditModeIndex] = useState(null);

  const toast = useToast();

  const [allFormValues, setAllFormValues] = useState([]);
  const [allForm, setAllForm] = useState([]);
  const [allValue, setAllValue] = useState([]);
  const [isSubmittted, setisSubmittted] = useState(false);
  useEffect(() => {
    if (scheduleViewId) fetchTasks(scheduleViewId);
  }, [scheduleViewId]);

  const fetchTasks = async (value) => {
    try {
      const response = await axiosInstance.get(`/schedules/forms/${value}`);
      console.log("Form ID", response.data?.data);
      const Data = response.data?.data;
      setisSubmittted(response?.data?.isSubmitted === false);
      setAllFormValues(Data);
      checkAllSubmitted();
      checkOtpEnable();
    } catch (error) {
      console.error("Error fetching tasks:", error);
    } finally {
    }
  };

  const [formId, setFormId] = useState(null);

  const fetchAllForm = async (value) => {
    setFormId(value);
    try {
      const formResponse = await axiosInstance.get(
        `/schedules/form-fields/${value}`
      );
      console.log(formResponse.data?.data);
      setAllForm(formResponse.data?.data);
      let TempArray = [];
      let tempFormData = formResponse.data?.data?.titles || [];
      tempFormData?.forEach((item) => {
        item?.fields?.forEach((field) => {
          console.log("Field - getting", field);
          let ValueInSide = {
            id: field?.id,
            field_type: field?.field_type,
            field_label: field?.field_label,
            value: field?.value,
          };
          TempArray.push(ValueInSide);
        });
      });
      setAllValue(TempArray);
    } catch (error) {
      console.error("Error fetching tasks:", error);
    } finally {
    }
  };

  const [expandedIndex, setExpandedIndex] = useState(null);
  const [showErrorFeild, setShowErrorFeild] = useState(false);
  const [ErrorMessage, setErrorMessage] = useState("");

  const handleToggle = (index, id) => {
    setAllForm([]);
    fetchAllForm(id);
    setExpandedIndex(index === expandedIndex ? null : index);
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {},
    validationSchema: yup.object({}),
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit: (values) => {
      let ValuesForForm = {
        isSubmitted: true,
        values: allValue,
        filesToRemove: [],
        oldSign1: removeSignOne || "",
        oldSign2: removeSignTwo || "",
      };
      let formData = new FormData();
      formData.append("json_data", JSON.stringify(ValuesForForm));
      filesList &&
        filesList.map((item) => {
          formData.append("attachments", item);
        });
      signOne &&
        formData.append(
          "signature1",
          signOne,
          `signature1-${formId}-${new Date().toISOString()}.png`
        );
      signTwo &&
        formData.append(
          "signature2",
          signTwo,
          `signature2-${formId}-${new Date().toISOString()}.png`
        );
      axiosInstance
        .put(`/schedules/form-submition/${formId}`, formData)
        .then((res) => {
          console.log("Form Submitted", res.data);
          if (res.data?.status === true) {
            toast.open({
              type: "success",
              message: "Success",
              description: res.data?.msg || "Created Successfully.",
            });
            CloseEditForm(formId);
          } else {
            toast.open({
              type: "error",
              message: "Error",
              description: res.data?.msg || "Network error.",
            });
            setShowErrorFeild(true);
            setErrorMessage(res.data?.data || "Network error.");
          }
        })
        .catch((error) => {
          toast.open({
            type: "error",
            message: "Error",
            description: error?.response?.data?.msg || "Network error.",
          });
        });
    },
  });


  async function CloseEditForm(id) {
    await axiosInstance
      .put(`/schedules/close-form/${id}`)
      .then((res) => {
        if (res?.data?.status) {
          console.log("ok");
          setEditModeIndex(null);
          fetchTasks(scheduleViewId);
        } else {
          console.log("error");
          toast.open({
            type: "error",
            message: "Error",
            description: res.data?.msg || "Network error.",
          });
        }
      })
      .catch((error) => {
        toast.open({
          type: "error",
          message: "Error",
          description: error?.response?.data?.msg || "Network error.",
        });
      });
  }

  async function OpenEditForm(index, id, workingUser) {
    if (workingUser) {
      CloseEditForm(id);
    } else {
      await axiosInstance
        .put(`/schedules/open-form/${id}`)
        .then((res) => {
          console.log("eeeee", res?.data?.status);

          if (res?.data?.status) {
            fetchTasks(scheduleViewId);
            setEditModeIndex(editModeIndex === index ? null : index);
          } else {
            console.log("error");
            toast.open({
              type: "error",
              message: "Error",
              description: res.data?.msg || "Network error.",
            });
          }
        })
        .catch((error) => {
          toast.open({
            type: "error",
            message: "Error",
            description: error?.response?.data?.msg || "Network error.",
          });
        });
    }
  }
  const [open, setOpen] = useState(false);

  const handleSendOTP = () => setOpen(true);
  const [allSubmitted, setAllSubmitted] = useState(false);

  const checkAllSubmitted = async () => {
    try {
      const response = await axiosInstance.get(
        `/schedules/check-submitted/${scheduleViewId}`
      );
      console.log("Check Submitted Status", response.data);

      setAllSubmitted(response.data?.data === true);
    } catch (error) {
      console.error("Error checking submission status:", error);
    }
  };

  useEffect(() => {
    if (scheduleViewId) {
      checkAllSubmitted();
      fetchTasks(scheduleViewId);
    }
  }, [scheduleViewId]);
  useEffect(() => {
    const interval = setInterval(() => {
      if (collectorSign.current) {
        collectorSign.current.off();
        clearInterval(interval);
      }
    }, 50);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (collectorSign.current) {
      isCollectorSignEnabled
        ? collectorSign.current.on()
        : collectorSign.current.off();
    }
  }, [isCollectorSignEnabled]);

  useEffect(() => {
    const interval = setInterval(() => {
      if (clientSign.current) {
        clientSign.current.off();
        clearInterval(interval);
      }
    }, 50);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (clientSign.current) {
      isClientSignEnabled ? clientSign.current.on() : clientSign.current.off();
    }
  }, [isClientSignEnabled]);

  const [otpEnable, setOtpEnable] = useState(false);

  const [openEnable, setEnableOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const checkOtpEnable = async () => {
    try {
      const response = await axiosInstance.get(`/schedules/is-otp-enabled`);
      console.log("Check Submitted Status", response.data);

      if (response.data?.status) {
        setOtpEnable(response.data.data === true);
      } else {
        console.warn("Unexpected response status:", response.data);
        setOtpEnable(false);
      }
    } catch (error) {
      console.error("Error checking submission status:", error);
      setOtpEnable(false);
    }
  };

  const handleEnableOTP = () => setEnableOpen(true);

  const handleVerifyOTP = () => {
    setLoading(true);
    axiosInstance
      .put(`/schedules/verify-otp/${scheduleViewId}`, { opt: "" })
      .then((res) => {
        if (res.data.status) {
          toast.open({
            type: "success",
            message: "OTP Verified",
          });
          fetchTasks(scheduleViewId);
        } else {
          toast.open({
            type: "error",
            message: "Invalid OTP",
            description: res.data.msg,
          });
        }
      })
      .catch((err) => {
        toast.open({
          type: "error",
          message: "Network Error",
          description: err.message,
        });
      })
      .finally(() => {
        setLoading(false);
        setEnableOpen(false);
      });
  };

  useEffect(() => {
    checkOtpEnable();
    fetchTasks(scheduleViewId);
  }, [scheduleViewId]);

  useEffect(() => {
    if (allForm?.signature1?.file) {
      setRemoveSignOne(allForm?.signature1?.file);
    }
    if (allForm?.signature2?.file) {
      setRemoveSignTwo(allForm?.signature2?.file);
    }
  }, [allForm]);

  return (
    <InSchedulelayout>
      <div className="flex flex-col h-full">
        <div className="flex-1 w-full h-full mt-0.5 overflow-y-auto">
          <div className="w-full mx-auto h-[calc(100vh-175px)]   pb-8">
            {allFormValues?.map((item, index) => (
              <React.Fragment key={item?.id || index}>
                <div className="border-b border-gray-300">
                  <div className="flex justify-between items-center p-2  bg-white">
                    <div className="flex items-center w-full justify-between gap-2">
                      <h1 className="text-sm font-semibold w-[35%] truncate">
                        {item.formName || " - "}
                      </h1>

                      <div className="flex 2xl:w-[50%] md:w-[65%] gap-2 justify-end items-center">
                        <div className="border border-baseColor-primary h-20 w-full bg-gray-50 rounded-lg mx-4  ml-2 p-2">
                          <div className="flex gap-2 w-full">
                            <div className="flex gap-2 w-[50%] ">
                              <table className=" w-full text-xs">
                                <tr className=" w-full">
                                  <td className=" w-[90px] pb-2 font-medium">
                                    Inspector
                                  </td>
                                  <td className=" w-[5px] pb-2">:</td>
                                  <td className=" pb-2  text-[#606279]">
                                    {item?.workingUserName || " "}
                                  </td>
                                </tr>
                                <tr>
                                  <td className=" w-[90px]  font-medium">
                                    Updated By
                                  </td>
                                  <td className=" w-[5px] ">:</td>
                                  <td className="  text-[#606279] font-medium">
                                    <div>
                                      <p>{item?.updatedByName || " "}</p>
                                    </div>
                                  </td>
                                </tr>
                                <tr>
                                  <td className=" w-[90px] "></td>
                                  <td className=" w-[5px]"></td>
                                  <td>
                                    <div>
                                      {item?.updatedByName &&
                                        item?.updatedOn && (
                                          <p className=" text-[10px] text-[#606279]">
                                            <NuDate
                                              value={item?.updatedOn}
                                              format="DD-MMM-YYYY, "
                                            />
                                            <NuDate
                                              value={item?.updatedOn}
                                              format="hh:mm a"
                                            />
                                          </p>
                                        )}
                                    </div>
                                  </td>
                                </tr>
                              </table>
                            </div>
                            <div className="flex gap-2 w-[50%] ">
                              <table className=" w-full text-xs">
                                <tr className=" w-full">
                                  <td className=" w-[110px] pb-1 font-medium">
                                    Status
                                  </td>
                                  <td className=" w-[5px] pb-1">:</td>
                                  <td className=" pb-1  text-[#606279] font-medium">
                                    {item?.status || "None"}
                                  </td>
                                </tr>
                                <tr>
                                  <td className=" w-[110px]  font-medium">
                                    Completion Date
                                  </td>
                                  <td className=" w-[5px] ">:</td>
                                  <td className="  text-[#606279] font-medium">
                                    <div>
                                      <p>
                                        <span>
                                          <NuDate
                                            value={item?.submittedOn}
                                            format="DD-MMM-YYYY, "
                                          />
                                        </span>
                                        <span>
                                          <NuDate
                                            value={item?.submittedOn}
                                            format="hh:mm a"
                                          />
                                        </span>
                                      </p>
                                    </div>
                                  </td>
                                </tr>
                                <tr>
                                  <td className=" w-[110px] "></td>
                                  <td className=" w-[5px]"></td>
                                  <td>
                                    <div></div>
                                  </td>
                                </tr>
                              </table>
                            </div>

                          </div>
                        </div>
                      </div>
                    </div>

                    {GetAccess("inspection_schedule_form_edit") &&
                      (GetRole() || isSubmittted) && (
                        <span
                          onClick={() =>
                            OpenEditForm(index, item?.id, item?.workingUser)
                          }
                          className={`cursor-pointer mr-4 p-1 rounded-lg border 
   ${
     editModeIndex === index
       ? "bg-green-100 border-green-500"
       : "bg-red-100 border-red-500"
   }`}
                        >
                          <EditIcon
                            color={editModeIndex === index ? "green" : "red"}
                            height={12}
                          />
                        </span>
                      )}

                    <span
                      onClick={() => handleToggle(index, item?.id)}
                      className={`cursor-pointer p-1.5 rounded-lg border transition flex items-center justify-center 
    ${
      expandedIndex === index
        ? "bg-blue-100 border-blue-500"
        : "bg-gray-100 border-gray-300"
    }`}
                    >
                      {expandedIndex === index ? (
                        <ToggleUp color="#3b82f6" width={14} height={10} />
                      ) : (
                        <ToggleDown color="#6b7280" width={14} height={10} />
                      )}
                    </span>
                  </div>
                </div>

                {expandedIndex === index && (
                  <form onSubmit={formik.handleSubmit}>
                    <CDynamicFormTwo
                      index={index}
                      formData={allForm?.titles || []}
                      expandedIndex={expandedIndex}
                      editModeIndex={editModeIndex}
                      allData={allForm}
                      allValue={allValue}
                      setAllValue={setAllValue}
                    />
                  </form>
                )}
              </React.Fragment>
            ))}
          </div>
        </div>

        {allSubmitted && isSubmittted && otpEnable && (
          <div className="w-full   p-4 flex justify-end">
            <SubmitButton name="Verify with OTP" handleClick={handleSendOTP} />
          </div>
        )}
        {!otpEnable && isSubmittted && (
          <div className="w-full p-4 flex justify-end">
            <SubmitButton name="Verify" handleClick={handleEnableOTP} />
          </div>
        )}
      </div>

      {open && (
        <SendOTP
          scheduleViewId={scheduleViewId}
          onClose={() => setOpen(false)}
          fetchTasks={fetchTasks}
        />
      )}
      {openEnable && (
        <ModalContainer
          visiable={openEnable}
          title="Confirm"
          content={
            <div>
              <p>
                Are You Sure! You want to{" "}
                <span className="font-semibold">Verify</span> this Form?
              </p>
            </div>
          }
          handleClick={handleVerifyOTP}
          closeModal={() => setEnableOpen(false)}
          isLoading={loading}
        />
      )}

      {showErrorFeild && (
        <ModalContainer
          closeModal={() => setShowErrorFeild(false)}
          visiable={showErrorFeild}
          title=""
          hasButton={false}
          content={
            <div className=" max-w-[65vw] max-h-[90vh] min-h-[30vh]  min-w-[65vw] 2xl:min-w-[45vw]">
              <div className="w-full h-7 mb-2 flex justify-between items-center">
                <p className=" font-semibold text-sm">Feilds to be checked</p>
                <div className=" flex gap-4 items-center">
                  <button
                    className=" text-white bg-red-600"
                    onClick={() => {
                      setShowErrorFeild(false);
                      setErrorMessage("");
                    }}
                  >
                    <svg
                      className="w-6 h-6"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M6 18L18 6M6 6l12 12"
                      />
                    </svg>
                  </button>
                </div>
              </div>
              <div className=" w-full max-h-[calc(90vh-32px)] overflow-y-auto">
                <pre>{ErrorMessage}</pre>
              </div>
            </div>
          }
        />
      )}
    </InSchedulelayout>
  );
}
export default FormSchedule;
